import { render, staticRenderFns } from "./CloneProducts.vue?vue&type=template&id=a1744120"
import script from "./CloneProducts.vue?vue&type=script&lang=js"
export * from "./CloneProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports